"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  neutral: {
    white: '#fff',
    _light_20: '#f9faf7',
    _light_40: '#eaebe8',
    _light_60: '#e5e5e3',
    _light_80: '#c8c9c5',
    _10: '#f7f7f7',
    _20: '#f0f0f0',
    _40: '#c7c7c7',
    _50: '#999999',
    _60: '#737373',
    _80: '#3D3D3D',
    _90: '#1A1A1A'
  },
  semantic: {
    $error10: '#ffeeed',
    $error50: '#e53832',
    $success10: '#DCFAE0',
    $success50: '#188428',
    $warning10: '#FFFAE4',
    $warning50: '#F7D02D',
    $warning70: '#E59500',
    $warning500: '#734f0b'
  },
  green: {
    _20: '#BDE5D6',
    _40: '#89D7B9',
    _50: '#41B989',
    _60: '#1D8B66',
    _70: '#0B654A',
    _80: '#004631',
    _90: '#002E20'
  },
  lime: {
    _20: '#f4fadc',
    _40: '#e2f6ac',
    _50: '#ccef6c',
    _60: '#ace119',
    _70: '#8bb616',
    _80: '#5e7b0f'
  },
  blue: {
    _10: '#f7f9ff',
    _20: '#ecf0ff',
    _40: '#c8d4ff',
    _50: '#6d8aed',
    _60: '#1a45db',
    _70: '#1136bb',
    _80: '#092277'
  },
  purple: {
    _20: '#FFEDFE',
    _40: '#E88BE5',
    _50: '#D047CC',
    _60: '#C730C2',
    _70: '#AD23A9',
    _80: '#80137C'
  },
  pink: {
    _20: '#FFE0ED',
    _40: '#FFB2D2',
    _50: '#FF8ABB',
    _60: '#FF61A3',
    _70: '#C21E63',
    _80: '#73113A'
  },
  shadow: {
    low: '0px 0px 4px rgba(21, 36, 31, 0.04), 0px 0px 16px rgba(238, 238, 238, 0.16)',
    medium: '0px 0px 6px rgba(21, 36, 31, 0.1), 0px 0px 16px rgba(238, 238, 238, 0.48)',
    high: '0px 0px 13px rgba(21, 36, 31, 0.1), 0px 0px 40px rgba(238, 238, 238, 0.24)'
  },
  gradient: {
    _3: 'radial-gradient(at 17% 49%, hsla(216,92%,91%,1) 0px, transparent 50%), radial-gradient(at 73% 100%, hsla(241,92%,14%,1) 0px, transparent 50%), radial-gradient(at 68% 25%, hsla(58,0%,100%,1) 0px, transparent 50%), radial-gradient(at 97% 23%, hsla(188,0%,100%,1) 0px, transparent 50%), radial-gradient(at 85% 59%, hsla(224,100%,81%,1) 0px, transparent 50%), radial-gradient(at 12% 11%, hsla(83,0%,100%,1) 0px, transparent 50%), radial-gradient(at 21% 97%, hsla(179,100%,46%,1) 0px, transparent 50%), radial-gradient(at 98% 98%, hsla(241,92%,14%,1) 0px, transparent 50%)'
  },
  monotone: {
    blue_simple: 'radial-gradient(at 75% 12%, hsla(30,0%,100%,1) 0px, transparent 50%), radial-gradient(at 22% 5%, hsla(226,60%,49%,1) 0px, transparent 50%), radial-gradient(at 9% 51%, hsla(217,0%,100%,1) 0px, transparent 50%), radial-gradient(at 3% 20%, hsla(226,80%,78%,1) 0px, transparent 50%),radial-gradient(at 46% 99%, hsla(226,78%,25%,1) 0px, transparent 50%), radial-gradient(at 97% 77%, hsla(228,84%,74%,1) 0px, transparent 50%), radial-gradient(at 85% 93%, hsla(228,84%,74%,1) 0px, transparent 50%)',
    green_simple: 'radial-gradient(at 5% 88%, hsla(71,100%,46%,1) 0px, transparent 50%), radial-gradient(at 13% 7%, hsla(183,100%,13%,1) 0px, transparent 50%), radial-gradient(at 55% 11%, hsla(72,100%,100%,1) 0px, transparent 50%), radial-gradient(at 92% 3%, hsla(76,100%,60%,1) 0px, transparent 50%), radial-gradient(at 0% 2%, hsla(183,100%,13%,1) 0px, transparent 50%)',
    orange_simple: 'radial-gradient(at 71% 93%, hsla(139,0%,100%,1) 0px, transparent 50%),radial-gradient(at 56% 44%, hsla(273,0%,100%,1) 0px, transparent 50%),radial-gradient(at 95% 8%, hsla(14,93%,55%,1) 0px, transparent 50%),radial-gradient(at 68% 6%, hsla(14,94%,55%,1) 0px, transparent 50%),radial-gradient(at 37% 37%, hsla(75,0%,100%,1) 0px, transparent 50%),radial-gradient(at 99% 60%, hsla(14,78%,44%,1) 0px, transparent 50%),radial-gradient(at 1% 61%, hsla(13,100%,72%,1) 0px, transparent 50%), radial-gradient(at 37% 93%, hsla(259,0%,100%,1) 0px, transparent 50%)',
    purple_simple: 'radial-gradient(at 49% 2%, hsla(301,0%,100%,1) 0px, transparent 50%),radial-gradient(at 3% 4%, hsla(301,66%,72%,1) 0px, transparent 50%),radial-gradient(at 70% 34%, hsla(166,0%,100%,1) 0px, transparent 50%),radial-gradient(at 98% 6%, hsla(301,61%,48%,1) 0px, transparent 50%),radial-gradient(at 30% 74%, hsla(259,0%,100%,1) 0px, transparent 50%),radial-gradient(at 99% 83%, hsla(302,66%,40%,1) 0px, transparent 50%)'
  }
};
exports.default = _default;